'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildPotentialResponders = undefined;

var _immutable = require('immutable');

var MAX_POTENTIAL_RESPONDERS = 3;

var buildPotentialResponders = exports.buildPotentialResponders = function buildPotentialResponders(sendFrom, responders) {
  var hasAgentResponders = responders && responders.size > 0;
  var hasSendFromResponders = sendFrom && sendFrom.size > 0;

  if (!hasSendFromResponders && !hasAgentResponders) {
    return (0, _immutable.List)();
  }

  if (hasSendFromResponders) {
    return sendFrom.take(MAX_POTENTIAL_RESPONDERS);
  }

  return responders.take(MAX_POTENTIAL_RESPONDERS);
};